module.exports = __webpack_public_path__ + "static/media/program-4.5e46af75.webp";